import { render, staticRenderFns } from "./IndicarRMA.vue?vue&type=template&id=7c54ed40&lang=pug"
import script from "./IndicarRMA.vue?vue&type=script&lang=js"
export * from "./IndicarRMA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports